import React, { useEffect, useState } from 'react';
import useAppState from '../../state/appState';
import { getArrayOfPagesShown } from '../../helpers/getPageInfo';
import { getPageIdFromURL } from '../../helpers/getPageIdFromURL';

export const PageArray = () => {
    const formConfig = useAppState((state) => state.formConfig);
    const formValues = useAppState((state) => state.formValues);

    const [pagesShown, setPagesShown] = useState<string[]>([]);

    // Since this lives outside of the app
    // (And outside of Routes)
    // it does not have access to useParams
    const pageId = getPageIdFromURL();

    useEffect(() => {
        if (formConfig) {
            getArrayOfPagesShown(formConfig, formValues).then((pageArray) => {
                setPagesShown(pageArray);
            });
        }
    }, [formConfig, formValues, pageId]);

    if (!formConfig) {
        return <></>;
    }

    return (
        <div>
            {pagesShown.map((pageId2, index) => (
                <div key={index}>
                    {pageId2 === pageId ? (
                        <strong>{pageId}</strong>
                    ) : pagesShown[index] && pageId2 !== pageId ? (
                        <em>{pageId2}</em>
                    ) : (
                        pageId
                    )}
                </div>
            ))}
        </div>
    );
};
